
<template>
  <a-card :bordered="false">
    <component
      @onEdit="handleEdit"
      @onStatus="handleStatus"
      @onRead="handleRead"
      @onGoBack="handleGoBack"
      :record="record"
      :is="currentComponet"></component>
  </a-card>
</template>

<script>

import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
// 动态切换组件
import List from '@/views/b-customs_order_inventory/table/OrderReadList'
import StatusList from '@/views/b-customs_order_inventory/table/StatusList'
export default {
  name: 'ExchangeRate',
  components: {
    AInput,
    ATextarea,
    List,
    StatusList
  },
  data () {
    return {
      currentComponet: 'List',
      record: ''
    }
  },
  created () {

  },
  methods: {
    handleEdit (record) {
      this.record = record || ''
      this.currentComponet = 'Edit'
      console.log(record)
    },
    handleStatus (record) {
      this.record = record || ''
      this.currentComponet = 'StatusList'
      console.log(record)
    },
    handleRead (record) {
      this.record = record || ''
      this.currentComponet = 'Read'
      console.log(record)
    },
    handleGoBack () {
      this.record = ''
      this.currentComponet = 'List'
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.currentComponet = 'List'
    }
  }
}
</script>
